import React, { useMemo } from "react";
import { motion } from "framer-motion";
import { TIER_COLORS } from "../lib/helpers";

// Lightweight dependency-free confetti burst. Pieces rain from the top across the
// width, tinted per rarity tier. Rendered only when motion is allowed.
export default function Confetti({ tier = "epic", count = 46 }) {
  const colors = TIER_COLORS[tier] || TIER_COLORS.epic;
  const pieces = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        drift: (Math.random() * 2 - 1) * 160,
        delay: Math.random() * 0.25,
        dur: 1.3 + Math.random() * 0.9,
        size: 6 + Math.random() * 9,
        rot: (Math.random() * 2 - 1) * 540,
        color: colors[i % colors.length],
        round: Math.random() > 0.5,
      })),
    [count, colors]
  );

  return (
    <div className="fixed inset-0 z-[60] pointer-events-none overflow-hidden" data-testid="confetti-burst">
      {pieces.map((p) => (
        <motion.div
          key={p.id}
          initial={{ y: "-12vh", x: 0, opacity: 1, rotate: 0 }}
          animate={{ y: "112vh", x: p.drift, opacity: [1, 1, 0.9, 0], rotate: p.rot }}
          transition={{ duration: p.dur, delay: p.delay, ease: "easeIn" }}
          style={{
            position: "absolute",
            top: 0,
            left: `${p.left}%`,
            width: p.size,
            height: p.size * (p.round ? 1 : 1.6),
            background: p.color,
            borderRadius: p.round ? "9999px" : "2px",
            boxShadow: `0 0 6px ${p.color}`,
          }}
        />
      ))}
    </div>
  );
}
